import { Link } from 'react-router-dom'
import { Bot, Zap, Shield, BarChart3, ArrowRight } from 'lucide-react'
import './Landing.css'

export default function Landing() {
  return (
    <div className="landing">
      {/* Hero */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="badge">
              <Zap size={16} />
              <span>AI-Powered Sales Agent</span>
            </div>
            <h1>
              Automatisez vos ventes 24/7 avec l'IA
            </h1>
            <p>
              Répondez aux clients, prenez les commandes et encaissez les paiements automatiquement.
              Pour les PME africaines.
            </p>
            <div className="cta">
              <Link to="/signup" className="btn btn-primary">
                Commencer gratuitement
                <ArrowRight size={20} />
              </Link>
              <Link to="/login" className="btn btn-secondary">
                Se connecter
              </Link>
            </div>
            <div className="stats">
              <div className="stat">
                <div className="stat-value">500+</div>
                <div className="stat-label">PME actives</div>
              </div>
              <div className="stat">
                <div className="stat-value">50K+</div>
                <div className="stat-label">Conversations/mois</div>
              </div>
              <div className="stat">
                <div className="stat-value">95%</div>
                <div className="stat-label">Taux de réponse</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="features">
        <div className="container">
          <h2>Fonctionnalités puissantes</h2>
          <div className="features-grid">
            <div className="feature-card">
              <Bot size={48} />
              <h3>IA Conversationnelle</h3>
              <p>Agent IA multilingue qui répond 24/7 en Wolof, Français, Anglais</p>
            </div>
            <div className="feature-card">
              <Shield size={48} />
              <h3>Sécurisé</h3>
              <p>Paiements intégrés via PayTech, Wave, Orange Money</p>
            </div>
            <div className="feature-card">
              <BarChart3 size={48} />
              <h3>Analytics Avancés</h3>
              <p>Tableau de bord avec KPIs, graphiques et export CSV</p>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing */}
      <section className="pricing">
        <div className="container">
          <h2>Tarification simple</h2>
          <div className="pricing-grid">
            <div className="pricing-card">
              <h3>Free</h3>
              <div className="price">0 FCFA</div>
              <ul>
                <li>50 conversations/mois</li>
                <li>1 canal (Web widget)</li>
                <li>Support email</li>
              </ul>
              <Link to="/signup" className="btn btn-outline">
                Commencer
              </Link>
            </div>
            <div className="pricing-card featured">
              <div className="badge">Populaire</div>
              <h3>Pro</h3>
              <div className="price">25,000 FCFA<span>/mois</span></div>
              <ul>
                <li>500 conversations/mois</li>
                <li>Tous les canaux (WhatsApp, Messenger, etc.)</li>
                <li>Analytics avancés</li>
                <li>Support prioritaire</li>
              </ul>
              <Link to="/signup" className="btn btn-primary">
                Choisir Pro
              </Link>
            </div>
            <div className="pricing-card">
              <h3>Enterprise</h3>
              <div className="price">100,000 FCFA<span>/mois</span></div>
              <ul>
                <li>Conversations illimitées</li>
                <li>API personnalisée</li>
                <li>Intégration custom</li>
                <li>Support dédié 24/7</li>
              </ul>
              <Link to="/signup" className="btn btn-outline">
                Contacter
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>&copy; 2026 Abawi Sales AI. Tous droits réservés.</p>
        </div>
      </footer>
    </div>
  )
}
